import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from '../LandingPage/FallbackPage';
import { ASSET_NAME } from './HelpCenterPage.duck';
import css from './HelpCenterPage.module.css';
import BackgroundLines from '../../components/Cobe/BackgroundLines/BackgroundLines';
import { FormattedMessage } from '../../util/reactIntl';
import HelpCenter from '../../components/Cobe/HelpCenter/HelpCenter';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const HelpCenterPageComponent = props => {
  const { pageAssetsData, inProgress, error, fetchInProgress } = props;

  if (fetchInProgress) {
    return null;
  }

  return (
    <>
      <PageBuilder
        pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
        inProgress={inProgress}
        error={error}
        fallbackPage={<FallbackPage error={error} />}
      >
        <section className={css.mainWrap}>
          {/* <BackgroundLines /> */}

          <div className={css.container}>
            <h2 className={css.pageTitle}>
              <FormattedMessage id="HelpCenter.PageTitle" />
            </h2>
            <HelpCenter />
          </div>
        </section>
      </PageBuilder>
    </>
  );
};

HelpCenterPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  const { currentUser } = state.user;

  return {
    pageAssetsData,
    inProgress,
    error,
    currentUser,
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const HelpCenterPage = compose(connect(mapStateToProps))(HelpCenterPageComponent);

export default HelpCenterPage;
